'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseAccessibilityTextArea = require('@bibliocommons/base-accessibility-text-area');

var _baseAccessibilityTextArea2 = _interopRequireDefault(_baseAccessibilityTextArea);

var _baseAccessibilityTextField = require('@bibliocommons/base-accessibility-text-field');

var _baseAccessibilityTextField2 = _interopRequireDefault(_baseAccessibilityTextField);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseIcon = require('@bibliocommons/base-icon');

var _baseIcon2 = _interopRequireDefault(_baseIcon);

var _baseIcons = require('@bibliocommons/base-icons');

var _videoEmbedCodeField = require('../../video-embed-code-field');

var _videoEmbedCodeField2 = _interopRequireDefault(_videoEmbedCodeField);

require('../styles/VideoForm.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VideoForm = exports.VideoForm = function (_BcReactComponent) {
  _inherits(VideoForm, _BcReactComponent);

  function VideoForm(props) {
    _classCallCheck(this, VideoForm);

    var _this = _possibleConstructorReturn(this, (VideoForm.__proto__ || Object.getPrototypeOf(VideoForm)).call(this, props));

    _this.state = {
      expanded: false,
      isEmpty: true
    };
    _this.bindAll('renderTitleField', 'renderDescriptionField', 'renderCancelButton', 'handleFocus', 'handleBlur');
    return _this;
  }

  _createClass(VideoForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'isAnyFieldPopuplated',
    value: function isAnyFieldPopuplated() {
      var _props = this.props,
          iFrameSrc = _props.iFrameSrc,
          videoTitle = _props.videoTitle,
          description = _props.description;

      return videoTitle || description || iFrameSrc;
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus() {
      this.setState({
        expanded: true
      });
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur() {
      this.setState({
        expanded: false
      });
    }
  }, {
    key: 'renderDescriptionField',
    value: function renderDescriptionField() {
      var _props2 = this.props,
          intl = _props2.intl,
          fieldErrors = _props2.fieldErrors,
          description = _props2.description,
          iFrameSrc = _props2.iFrameSrc,
          handleDescriptionChange = _props2.handleDescriptionChange,
          submitting = _props2.submitting;


      return _react2.default.createElement(_baseAccessibilityTextArea2.default, {
        errorKey: 'description',
        fieldErrors: fieldErrors,
        className: 'input-lg',
        value: description,
        handleChange: handleDescriptionChange,
        maxLength: 500,
        handleFocus: this.handleFocus,
        handleBlur: this.handleBlur,
        placeholder: intl.formatMessage({ id: 'video_description' }),
        disabled: submitting || !iFrameSrc });
    }
  }, {
    key: 'renderTitleField',
    value: function renderTitleField() {
      var _props3 = this.props,
          intl = _props3.intl,
          videoTitle = _props3.videoTitle,
          fieldErrors = _props3.fieldErrors,
          handleTitleChange = _props3.handleTitleChange,
          iFrameSrc = _props3.iFrameSrc,
          focusTitle = _props3.focusTitle,
          submitting = _props3.submitting;

      return _react2.default.createElement(_baseAccessibilityTextField2.default, {
        errorKey: 'title',
        fieldErrors: fieldErrors,
        className: 'input-lg',
        value: videoTitle,
        disabled: submitting || !iFrameSrc,
        handleFocus: this.handleFocus,
        handleBlur: this.handleBlur,
        focus: focusTitle,
        placeholder: intl.formatMessage({ id: 'video_title' }),
        handleChange: handleTitleChange,
        maxLength: 50 });
    }
  }, {
    key: 'renderDeleteButton',
    value: function renderDeleteButton() {
      var _props4 = this.props,
          handleDelete = _props4.handleDelete,
          submitting = _props4.submitting;


      return _react2.default.createElement(
        'button',
        { type: 'button', className: 'btn btn-link', onClick: handleDelete, disabled: submitting },
        _react2.default.createElement(_baseIcon2.default, { icon: 'icon-trash' }),
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'delete_button' })
      );
    }
  }, {
    key: 'renderCancelButton',
    value: function renderCancelButton() {
      var _props5 = this.props,
          handleCancel = _props5.handleCancel,
          submitting = _props5.submitting,
          intl = _props5.intl;


      return _react2.default.createElement('input', { type: 'reset', onClick: handleCancel, className: 'btn btn-link pull-right', value: intl.formatMessage({ id: 'cancel_button' }), disabled: submitting });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          intl = _props6.intl,
          iFrameSrc = _props6.iFrameSrc,
          submitting = _props6.submitting,
          fieldErrors = _props6.fieldErrors,
          videoTitle = _props6.videoTitle,
          description = _props6.description,
          embedSnippet = _props6.embedSnippet,
          handleSubmit = _props6.handleSubmit,
          handleCancelPreview = _props6.handleCancelPreview,
          handleCancel = _props6.handleCancel,
          handleEmbedSnippetChange = _props6.handleEmbedSnippetChange;
      var expanded = this.state.expanded;

      var isEmpty = !iFrameSrc || !videoTitle;
      var disableSubmit = submitting || isEmpty;
      var buttonClass = !isEmpty ? 'btn-primary' : 'btn-default';
      var formClass = expanded || !isEmpty ? 'active' : '';

      return _react2.default.createElement(
        'form',
        { onSubmit: handleSubmit, className: 'cp-video-form clearfix well ' + formClass + ' ' },
        _react2.default.createElement(
          'h3',
          { className: 'form-title' },
          _react2.default.createElement(_baseIcons.Video, null),
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'enter_a_video' })
        ),
        _react2.default.createElement(_videoEmbedCodeField2.default, {
          fieldErrors: fieldErrors,
          embedSnippet: embedSnippet,
          iFrameSrc: iFrameSrc,
          handleCancelPreview: handleCancelPreview,
          handleEmbedSnippetChange: handleEmbedSnippetChange,
          handleFocus: this.handleFocus,
          handleBlur: this.handleBlur,
          disabled: submitting }),
        videoTitle || iFrameSrc ? this.renderTitleField() : null,
        description || iFrameSrc ? this.renderDescriptionField() : null,
        _react2.default.createElement(
          'div',
          { className: 'ugc-actions' },
          this.props.handleDelete ? this.renderDeleteButton() : null,
          _react2.default.createElement('input', { type: 'submit', value: intl.formatMessage({ id: this.props.submitButtonText }), className: 'btn ' + buttonClass + ' pull-right', disabled: disableSubmit }),
          !!handleCancel && this.isAnyFieldPopuplated() ? this.renderCancelButton() : null
        )
      );
    }
  }]);

  return VideoForm;
}(_baseBcReactComponent2.default);

VideoForm.propTypes = {
  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
    classification: _react.PropTypes.string,
    message: _react.PropTypes.string
  })),
  submitting: _react.PropTypes.bool.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  formHeadingText: _react.PropTypes.string.isRequired,
  submitButtonText: _react.PropTypes.string.isRequired,
  iFrameSrc: _react.PropTypes.string,
  focusTitle: _react.PropTypes.bool,
  embedSnippet: _react.PropTypes.string,
  videoTitle: _react.PropTypes.string,
  description: _react.PropTypes.string,
  handleTitleChange: _react.PropTypes.func,
  handleDescriptionChange: _react.PropTypes.func,
  handleCancel: _react.PropTypes.func.isRequired,
  handleCancelPreview: _react.PropTypes.func.isRequired,
  handleEmbedSnippetChange: _react.PropTypes.func.isRequired,
  handleDelete: _react.PropTypes.func.isRequired,
  characterLimit: _react.PropTypes.number,
  expanded: _react.PropTypes.bool.isRequired,
  isEmpty: _react.PropTypes.bool.isRequired,
  handleBlur: _react.PropTypes.func.isRequired,
  handleFocus: _react.PropTypes.func.isRequired,
  intl: _reactIntl.intlShape
};

VideoForm.defaultProps = {
  user: { loggedIn: false },
  submitting: false,
  handleCancel: false,
  handleDelete: false
};

exports.default = (0, _reactIntl.injectIntl)(VideoForm);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-ugc-editors/lib/components/video-form/components/VideoForm.js
// module id = 1540
// module chunks = 1